"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoresContext = void 0;
const react_1 = __importDefault(require("react"));
const root_store_1 = __importDefault(require("@App/stores/root-store"));
/**
 * A React context that (will) contain all global MobX stores
 */
const rootStore = new root_store_1.default();
exports.StoresContext = react_1.default.createContext(Object.assign({}, rootStore));
